module.exports = __webpack_public_path__ + "static/media/fresnel_small.d156cdd0.png";